<template>
		<cartContainer :ptInitData="ptInitData" :doChkCartAddTxt="doChkCartAddTxt" :isLp="isLp" :teikiKounyuu="0"
			@pt125doOrder="pt125doOrder" />
</template>
<script>
import cartContainer from './cartContainer.vue'
export default {
	name: 'generalCartContainer',
	components: {
		cartContainer
	},
	props: {
		ptInitData: {
			type: Object,
			default: null,
		},
		doChkCartAddTxt: {
			type: Boolean
		},
		isLp: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
		}
	},
	methods: {
		pt125doOrder: function (e) {
			this.$emit('pt125doOrder', e);
		}
	}
}
</script>